module.exports = __webpack_public_path__ + "img/en.b8a75c53.svg";